import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgModule } from '@angular/core';
import { QRCodeComponent } from 'angularx-qrcode';
import { CoreModule } from './../core/core.module';
import { AddressComponent } from './component/address/address.component';
import { BankIdAuthComponent } from './component/bankid-auth/bankid-auth.component';
import { BankIdQrComponent } from './component/bankid-qr/bankid-qr.component';
import { ChangePasswordComponent } from './component/change-password/change-password.component';
import { ChatInputMessageComponent } from './component/chat/chat-input-message/chat-input-message.component';
import { ChatMessageFilesComponent } from './component/chat/chat-message-files/chat-message-files.component';
import { ChatMessageComponent } from './component/chat/chat-message/chat-message.component';
import { ChatUserLogoComponent } from './component/chat/chat-user-logo/chat-user-logo.component';
import { ChatComponent } from './component/chat/chat.component';
import { ContactIdComponent } from './component/contact-id/contact-id.component';
import { DeliveryMethodComponent } from './component/delivery-method/delivery-method.component';
import { ExecutorGroupFormComponent } from './component/executor-group-form/executor-group-form.component';
import { ExecutorGroupManagerComponent } from './component/executor-group-manager.component/executor-group-manager.component';
import { FormHeaderComponent } from './component/form-header/form-header.component';
import { GlobalSearchComponent } from './component/global-search/global-search.component';
import { LanguageComponent } from './component/language/language.component';
import { LoginComponent } from './component/login/login.component';
import { LogoComponent } from './component/logo/logo.component';
import { OrganizationNumberComponent } from './component/organization-number/organization-number.component';
import { PostalAddressComponent } from './component/postal-address/postal-address.component';
import { ProfileModuleComponent } from './component/profile-module/profile-module.component';
import { ProfileSettingsComponent } from './component/profile-settings/profile-settings.component';
import { ProfileComponent } from './component/profile/profile.component';
import { RegisterDemoComponent } from './component/register-demo/register-demo.component';
import { ResetPasswordComponent } from './component/reset-password/reset-password.component';
import { SelectDateDialogComponent } from './component/select-date-dialog/select-date-dialog.component';
import { SelectDialogComponent } from './component/select-dialog/select-dialog.component';
import { SortFormComponent } from './component/sort-form/sort-form.component';
import { StaircaseListComponent } from './component/staircase-list/staircase-list.component';
import { SupportFormComponent } from './component/support-form/support-form.component';
import { UserFormComponent } from './component/user-form/user-form.component';
import { UserGroupFormComponent } from './component/user-group-form/user-group-form.component';
import { UserGroupManagerComponent } from './component/user-group-manager/user-group-manager.component';
import { UserManagerComponent } from './component/user-manager/user-manager.component';
import { AutoLogoutService } from './service/auto-logout-service';
import { ChatService } from './service/chat-service';
import { AccountService } from './service/data/account.service';
import { CountryService } from './service/data/country.service';
import { ExecutorGroupService } from './service/data/executor-group.service';
import { FaultNotificationExecutorService, RoundingExecutorService } from './service/data/executor-webuser.service';
import { LicenseService } from './service/data/license.service';
import { ProfileService } from './service/data/profile.service';
import { ProfileManagementService } from './service/data/profile-management.service';
import { SystemOwnerSettingsLogService } from './service/data/system-owner-settings-log.service';
import { UserGroupService } from './service/data/user-group.service';
import { UserService } from './service/data/user.service';
import { FilePreviewService } from './service/file-preview.service';
import { AccountingGuard } from './service/guard/accounting-guard.service';
import { AnonymousGuard } from './service/guard/anonymous-guard.service';
import { AuthGuard } from './service/guard/auth-guard.service';
import { DwellingInspectionGuard } from './service/guard/dwelling-inspection-guard.service';
import { FaultNotificationGuard } from './service/guard/fault-notification-guard.service';
import { ImdGuard } from './service/guard/imd-guard.service';
import { InvoicingGuard } from './service/guard/invoicing-guard.service';
import { LandlordAccountGuard } from './service/guard/landlord-guard.service';
import { LettingFeatureGuard } from './service/guard/letting-feature-guard.service';
import { MessagesGuard } from './service/guard/messages-guard.service';
import { RentGuard } from './service/guard/rent-guard.service';
import { IdNumberValidatorService } from './service/id-number-validator-service';
import { HelpPageComponent } from './component/help-page/help-page.component';
import { UserAccountMenuComponent } from './component/user-account-menu/user-account-menu.component';
import { LanguageSelectComponent } from './component/language-select/language-select.component';
import { ToolbarMenuComponent } from './component/toolbar-menu/toolbar-menu.component';
import { LocationAccessGroupManagerComponent } from './component/location-access-group-manager/location-access-group-manager.component';
import { LocationAccessGroupService } from './service/data/location-access-group.service';
import { LocationAccessGroupFormComponent } from './component/location-access-group/location-access-group-form.component';
import { FormHeaderStateService } from './service/form-header-state.service';
import { HomepalService } from './service/data/homepal.service';
import { PriceListFormComponent } from '../common/component/pricelist-form/pricelist-form.component';
import { ImportPriceListFormComponent } from '../common/component/import-pricelist-form/import-pricelist-form.component';
import { PriceListItemFormComponent } from '../common/component/pricelist-item-form/pricelist-item-form.component';
import { PriceListManagerComponent } from '../common/component/pricelist-item-manager/pricelist-manager.component';
import { PriceListItemPerPriceListAutocompleteService } from './service/price-list-item-per-price-list-autocomplete.service';
import { CommonPricelistsGuardService } from './service/guard/common-pricelists-guard.service';
import { DocumentViewComponent } from './component/document-view/document-view.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { UserResourceService } from './service/data/user-resource.service';
import { ProgressBarCountdownComponent } from './component/progress-bar-countdown/progress-bar-countdown.component';
import { NewsPopupComponent } from './component/news-popup/news-popup.component';
import { NotificationSettingComponent } from './component/notification-setting/notification-setting.component';
import { NotificationSettingService } from './service/data/notification-setting';
import { BankIdService } from './service/data/bankId.service';
import { ExcelExportService } from '../core/service/excel-export.service';
import { PriceListService } from './service/data/pricelist.service';

@NgModule({
  imports: [CoreModule, DragDropModule, QRCodeComponent, PdfViewerModule],
  declarations: [
    AddressComponent,
    ContactIdComponent,
    PostalAddressComponent,
    OrganizationNumberComponent,
    SupportFormComponent,
    LogoComponent,
    ChangePasswordComponent,
    LanguageComponent,
    BankIdAuthComponent,
    BankIdQrComponent,
    LocationAccessGroupManagerComponent,
    LocationAccessGroupFormComponent,
    LoginComponent,
    NewsPopupComponent,
    ProfileComponent,
    ProfileSettingsComponent,
    ProfileModuleComponent,
    ProgressBarCountdownComponent,
    RegisterDemoComponent,
    ResetPasswordComponent,
    StaircaseListComponent,
    UserManagerComponent,
    UserFormComponent,
    UserGroupManagerComponent,
    UserGroupFormComponent,
    FormHeaderComponent,
    SelectDateDialogComponent,
    SelectDialogComponent,
    SortFormComponent,
    DeliveryMethodComponent,
    ChatComponent,
    ChatMessageComponent,
    ChatInputMessageComponent,
    ChatUserLogoComponent,
    ChatMessageFilesComponent,
    ExecutorGroupManagerComponent,
    ExecutorGroupFormComponent,
    HelpPageComponent,
    UserAccountMenuComponent,
    LanguageSelectComponent,
    ToolbarMenuComponent,
    PriceListFormComponent,
    PriceListItemFormComponent,
    PriceListManagerComponent,
    ImportPriceListFormComponent,
    DocumentViewComponent,
    GlobalSearchComponent,
    NotificationSettingComponent,
  ],
  providers: [
    AccountingGuard,
    AnonymousGuard,
    AuthGuard,
    AutoLogoutService,
    IdNumberValidatorService,
    ImdGuard,
    CountryService,
    DwellingInspectionGuard,
    FaultNotificationGuard,
    HomepalService,
    LandlordAccountGuard,
    LettingFeatureGuard,
    LocationAccessGroupService,
    InvoicingGuard,
    MessagesGuard,
    RentGuard,
    AccountService,
    BankIdService,
    ProfileService,
    ProfileManagementService,
    SystemOwnerSettingsLogService,
    UserService,
    UserGroupService,
    ChatService,
    ExecutorGroupService,
    FaultNotificationExecutorService,
    RoundingExecutorService,
    LicenseService,
    FilePreviewService,
    FormHeaderStateService,
    PriceListItemPerPriceListAutocompleteService,
    CommonPricelistsGuardService,
    UserResourceService,
    NotificationSettingService,
    ExcelExportService,
    PriceListService,
  ],
  exports: [
    AddressComponent,
    ContactIdComponent,
    PostalAddressComponent,
    OrganizationNumberComponent,
    SupportFormComponent,
    LogoComponent,
    ChangePasswordComponent,
    LanguageComponent,
    LocationAccessGroupManagerComponent,
    LoginComponent,
    NewsPopupComponent,
    ProfileComponent,
    ProfileSettingsComponent,
    ProfileModuleComponent,
    RegisterDemoComponent,
    ResetPasswordComponent,
    StaircaseListComponent,
    UserManagerComponent,
    UserFormComponent,
    UserGroupManagerComponent,
    UserGroupFormComponent,
    FormHeaderComponent,
    DeliveryMethodComponent,
    ChatComponent,
    ChatMessageComponent,
    ChatInputMessageComponent,
    ChatUserLogoComponent,
    ChatMessageFilesComponent,
    ExecutorGroupManagerComponent,
    ExecutorGroupFormComponent,
    HelpPageComponent,
    ToolbarMenuComponent,
    DocumentViewComponent,
    GlobalSearchComponent,
    NotificationSettingComponent,
    PriceListItemFormComponent,
    PriceListManagerComponent,
  ],
})
export class CommonModule {}
